

import React, { useState, useEffect,useRef} from "react"; // 引入 React 核心库以及常用的 hooks：useState（状态管理）和 useEffect（副作用处理）
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Diagram from "@/Components/Diagram"; // 引入流程图主组件，负责渲染和编辑流程图
import Palette from "@/Components/Diagram/Palette"; // 引入图形库组件，提供可拖拽的图形元素
import Overview from "@/Components/Diagram/Overview"; // 引入缩略图组件，用于显示流程图全局视图
import userInfo from "@/Components/user"; // 引入当前用户信息对象，用于记录创建人/更新人
import dayjs from "dayjs"; // 引入 dayjs 库，用于格式化日期时间
import flowJosn from '../../../Main/flow.json' // 引入本地的流程图 JSON 数据（可能是备用或示例数据，文件名有拼写错误 flowJosn -> flowJson）
import tempJosn from '../../../Main/temp.json'
import testJosn from '../../../Main/test.json'
import emptyJosn from '../../../Main/empty.json'
import {useAppContext } from "@/AppContext";
import {getFlow,saveFlow,projectsAll,simulation} from "@/services/common";
import {message,Modal,TreeSelect,Input,Checkbox,Row,Col,Typography} from "antd";
const { Text } = Typography;
import type { TreeSelectProps } from 'antd';
import {LoadingOutlined,EyeOutlined,EditOutlined,SaveOutlined,FileOutlined,CopyOutlined,VerticalAlignBottomOutlined,VerticalAlignTopOutlined,SwapOutlined,UndoOutlined,RedoOutlined,GroupOutlined,UngroupOutlined,FullscreenOutlined,FullscreenExitOutlined,ExpandOutlined,ExpandAltOutlined,SearchOutlined} from "@ant-design/icons";
import {elementDesc,typeMap,typeMap2,fieldMap2,typeMap3} from "@/constants/dataMap";
import SelectElementsModal, { buildTaskInput } from "@/Components/Diagram/SelectElementsModal";
import elementJson from "@/Components/Diagram/elements.json";
import towerJson from "@/Components/Diagram/elementsData/tower.json";
import test_Rectisol from "@/constants/test_Rectisol.json";
import input69 from "@/constants/test_Distil_Absorber.json";
import {updateFlowthum_Pic} from "@/config/func";
import { unitMap, materialsValueMap } from "@/constants/dataMap";
import SearchElement from "./searchElement";

import element from "@/Components/Diagram/newElements.json";
import boiler from "@/Components/Diagram/elementsData/boiler.json";
import comments from "@/Components/Diagram/elementsData/comments.json";
import container from "@/Components/Diagram/elementsData/container.json";
import equipment from "@/Components/Diagram/elementsData/equipment.json";
import heatExchanger from "@/Components/Diagram/elementsData/heatExchanger.json";
import others from "@/Components/Diagram/elementsData/others.json";
import products from "@/Components/Diagram/elementsData/products.json";
import pump from "@/Components/Diagram/elementsData/pump.json";
import reactor from "@/Components/Diagram/elementsData/reactor.json";
import separator from "@/Components/Diagram/elementsData/separator.json";
import tank from "@/Components/Diagram/elementsData/tank.json";
import tower from "@/Components/Diagram/elementsData/tower.json";
import Flash2 from "@/Components/Diagram/elementsData/Flash2.json";

interface ComponentProps 
{
  allowUpDiagrams?:boolean;
  action?:"deleteDiagram"|"handleData"|"saveDiagram"| null;
  onActionDone?: () => void;
  onReadonlyChange?: (readonly: boolean) => void;
}

const elementsDatas = 
{
  boiler, comments, container, equipment,
  ShellAndTubeExchanger: heatExchanger,
  others, products, pump, reactor,
  Splitter: separator, tank, DistilStrict: tower,Flash2
};

// const Component = (props:ComponentProps) => 
const Component: React.FC<ComponentProps> = ({ allowUpDiagrams,action,onActionDone,onReadonlyChange }) =>
{
  // const {allowUpDiagrams} = props;
  // 定义状态：diagrams 存储流程图实例对象（通常是 mxGraph 的实例）
  const [diagrams, setDiagrams] = useState<any>(null);
  // 定义状态：overview 控制缩略图组件的显示/隐藏，默认为 false（不显示）
  const [overview, setOverview] = useState<boolean>(false);
  // 定义状态：dataSource 存储从后端获取的流程图数据源（包括流程图元数据、图形数据等）
  const [dataSource, setDataSource] = useState<any>(null);
  const [globalData, setGlobalData] = useState<any>(null);
  const {state,actions} = useAppContext();
  const [messageApi, contextHolder] = message.useMessage();
  const [allProjectData, setAllProjectData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [selectCopyFlowUrl, setSelectCopyFlowUrl] = useState("");
  const [queryAllProjectStatu, setQueryAllProjectStatu] = useState(1);  //1:没查，2：正在查，3：查完
  const [overviewVisible,setOverviewVisible] = useState(true);
  const saveDiagramRef = useRef(null);
  const [readonly, setReadonly] = useState<boolean>(() => {return !allowUpDiagrams;});
  const navigate = useNavigate();
  const [fullScreenViable, setFullScreenViable] = useState(false);
  const [screenSize,setScreenSize] = useState<number>(100);
  const [selectedElements,setSelectedElements] = useState<string[]>([]);
  const params = useParams<{ k: string; f: string; j: string }>();
  const [taskModalVisible, setTaskModalVisible] = useState(false);
  const [currentJsonDataForTask, setCurrentJsonDataForTask] = useState<any>(null);
  const diagramRef = useRef(null);
  const [loadingVariable,setLoadingVariable] = useState(false);
  const [searchElementName,setSearchElementName] = useState(null);
  const streamsBasicParams = [
    { p_name: "类型", p_engName: "type", p_show: true, enum: [{ label: "进料", value: "进料" }, { label: "出料", value: "出料" }, { label: "内部", value: "内部" }] },
    { p_name: "物性计算方法", p_engName: "physical_method", p_show: true, enum: [{ label: "NRTL-RK", value: "NRTL" }, { label: "SRK", value: "SRK" }] },
    { p_name: "相态", p_engName: "phase", p_show: true, enum: [{ label: "L-液相", value: "L" }, { label: "V-汽相", value: "V" }, { label: "VL-汽液两相", value: "VL" }] },
    { p_name: "计算模式", p_engName: "mode", p_show: true, enum: [{ label: "TP-温压闪蒸", value: "TP" }, { label: "VP-汽化率压力闪蒸", value: "VP" }, { label: "HP-压焓闪蒸", value: "HP" }] },
    {p_name: "流股属性",p_engName: "streamAttribute",p_show: true,enum: [{ label: "无", value: "无" },{ label: "冷流股", value: "冷流股" },{ label: "热流股", value: "热流股" },],},
    { p_name: "流量", p_engName: "f", p_show: true, p_unitField: "", p_unit: ["kg/h"],p_value:"16500.19495" },
    { p_name: "温度", p_engName: "t", p_show: true, p_unitField: "",p_type:"T", p_unit: unitMap["T"],p_value:"120" },
    { p_name: "压力", p_engName: "p", p_show: true, p_unitField: "",p_type:"P", p_unit: unitMap["P"],p_value:"50.49" },
  ];

  useEffect(() => 
  {
    queryCurFlow();

    //测试数据
    // setDataSource({ data: testJosn, cover: '' });
  }, []);

  useEffect(() => 
  {
    if (onReadonlyChange) 
    {
      onReadonlyChange(readonly);
    }
  }, [readonly,onReadonlyChange]);

  useEffect(() => 
  {
    const handleFullscreenChange = () => 
    {
      setFullScreenViable(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  useEffect(() => 
  {
    if(searchElementName && diagrams)
    {
      //画面跳转
      const model = diagrams.model;
      let targetPart = null;
      let targetKey = null;

      if(searchElementName.type==="node")
      {
        const node = model.nodeDataArray.find((n: any) => n.nodeName === searchElementName.name && !n.isGroup);
        if (node) 
        {
          targetKey = node.key;
          targetPart = diagrams.findNodeForKey(targetKey);
        }
      }
      else if(searchElementName.type==="link")
      {
        const link = model.linkDataArray.find((l: any) => l.linkName === searchElementName.name);
        if(link) 
        {
          targetKey = link.key;
          targetPart = diagrams.findLinkForKey(targetKey);
        }
      }

      if (targetPart) 
      {
        // 居中显示
        diagrams.centerRect(targetPart.actualBounds);
        // 选中图元
        diagrams.select(targetPart);
      }
      else
      {
        messageApi.open
        ({
          type: "error",
          content: "类型有误，查询失败",
        });
      }
      setSearchElementName(null)
    }
  }, [searchElementName,diagrams]);

  //查询当前流程图
  const queryCurFlow = () => 
  {
    let token = userInfo.access_token
    const projectId = params.k;
    const flowId = params.f;

    getFlow(projectId,flowId,token).then(async (res) => 
    {
      if(res.status===200)
      {
        if(res.data.flow_data_url)
        {
          let flowDataUrl = res.data.flow_data_url;
          let global_data = res.data.global_data;
          let response = await fetch(flowDataUrl);
          let jsonData = await response.json();
          setDataSource({data:jsonData,cover:''});
          setGlobalData(global_data);
        }
        else
        {
          let global_data = res.data.global_data;
          setGlobalData(global_data);
          setDataSource({data:emptyJosn,cover:''});
        }
      }
      else
      {
        messageApi.open
        ({
            type: "error",
            content:`查询失败：${res.status}`,
        });
        let global_data = 
        {
          globle_physical_method:"",
          materials:[]
        }
        setGlobalData(global_data);
        setDataSource({data:emptyJosn,cover:''});
      }
    });
  };

  // 切换只读/编辑模式的函数
  const toggleReadOnlyMode = () => 
  {
    setReadonly(!readonly); // 将 readonly 状态取反
    // 打印当前切换后的模式（由于 setState 是异步的，这里打印的是旧值，但可反映意图）
    console.log(`已切换到${readonly ? '编辑' : '只读'}模式`);
  };


  // 获取与节点相连的流股（方向：in/out）
  const getRelatedLinks = (diagrams: any, nodeKey: string, direction: 'in' | 'out') => 
  {
    const model = diagrams.model;
    const linkDataArray = model.linkDataArray;
    return linkDataArray.filter((link: any) => {
      if (direction === 'in') return link.to === nodeKey;
      return link.from === nodeKey;
    });
  };

  // 生成节点的默认 ParamValues
  const generateNodeDefaultParamValues = (nodeData: any, diagrams: any) => 
  {
    const paramValues = {};
    const type = nodeData.type;
    const name = nodeData.elementName;
    let params: any[] = [];
    let nodeName = nodeData.nodeName??"";

    // 获取参数定义（与 Diagram 中 openInputParams 逻辑一致）
    if (element.filter((item: any) => item.typeID == type).length > 0) 
    {
      params = element.filter((item: any) => item.typeID == type)[0].params;
    }
    if (elementsDatas[type] !== undefined) 
    {
      const matched = elementsDatas[type].filter((item: any) => item.name == name);
      if (matched.length > 0 && matched[0].params) 
      {
        params = params.concat(matched[0].params);
      }
    }

    // 为每个参数生成默认值
    params.forEach(param => 
    {
      const paramName = param.p_name;
      if (param.p_children && Array.isArray(param.p_children) && param.p_children.length > 0) 
      {
        // 处理 Ns/No 等特殊子项
        if (param.p_engName === 'Ns' || param.p_engName === 'No')
        {
          const nodeKey = nodeData.key;
          const direction = param.p_engName === 'Ns' ? 'in' : 'out';
          const links = getRelatedLinks(diagrams, nodeKey, direction);
          const p_children = links.map((link: any) => ({
            流股: {
              value: link.text || link.linkName || '',
              desValue: link.text || link.linkName || '',
              show: true,
              engName: 'streamName',
              readonly: true,
            },
            [param.p_engName === 'Ns' ? '进料位置' : '出料位置']: {
              // value: param.p_value ?? '',
              value: (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.[param.p_engName === "Ns"?"inputStreams":"outputStreams"]).findIndex(item=>item.name===(link.text || link.linkName || ''))] )??(param.p_children.find(item=>item.p_engName==="进料位置"||item.p_engName==="出料位置"||item.p_engName==="输出流量").p_value ?? ''),
              desValue:(nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.[param.p_engName === "Ns"?"inputStreams":"outputStreams"]).findIndex(item=>item.name===(link.text || link.linkName || ''))] )??(param.p_children.find(item=>item.p_engName==="进料位置"||item.p_engName==="出料位置"||item.p_engName==="输出流量").p_value ?? ''),
              show: true,
              engName: param.p_engName === 'Ns' ? '进料位置' : '出料位置',
            },
          }));
          paramValues[paramName] = 
          {
            show: param.p_show ?? false,
            engName: param.p_engName,
            p_children,
          };
        }
        else if(param.p_engName === "stream_type")
        {
          let defaultChildren = [{}];
          for(let i=0;i<param.p_children.length;i++)
          {
            let defaultChild = 
            {
              "value":param.p_children[i].p_value,
              "desValue":param.p_children[i].p_value,
              "show":param.p_children[i].p_show,
              "engName":param.p_children[i].p_engName,
            };
            defaultChildren[0][param.p_children[i].p_name] = defaultChild;
          }

          paramValues[paramName] = 
          {
            show: param.p_show ?? false,
            engName: param.p_engName,
            p_children: defaultChildren,
          };
        }
        else 
        {
          // 普通 p_children，初始为空数组
          paramValues[paramName] = 
          {
            show: param.p_show ?? false,
            engName: param.p_engName,
            p_children: [],
          };
        }
      } 
      else if(param.enum && param.enum.length > 0) 
      {
        // 枚举类型：默认值取第一个
        paramValues[paramName] = {
          value: param.enum[0].value,
          desValue: param.enum[0].value,
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      } 
      else if(param.p_unit && param.p_unit.length > 0) 
      {
        // 有单位字段：value 默认空字符串，单位取第一个
        paramValues[paramName] = {
          // value: param.p_value ?? '',
          value: (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName])??(param.p_value ?? ''),
          desValue:(nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName])??(param.p_value ?? ''),
          unit: param.p_unit[0],
          show: param.p_show ?? false,
          engName: param.p_engName,
          unitField: param.p_unitField ?? null,
        };
      } 
      else 
      {
        // 普通输入框
        paramValues[paramName] = 
        {
          // value: param.p_value ?? '',
          value: (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName])??(param.p_value ?? ''),
          desValue: (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName])??(param.p_value ?? ''),
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      }
    });
    return paramValues;
  };

  // 生成连接线的默认 ParamValues
  const generateLinkDefaultParamValues = (linkData: any) => 
  {
    const paramValues = {};
    streamsBasicParams.forEach(param => 
    {
      const paramName = param.p_name;
      if (param.enum && param.enum.length > 0) 
      {
        paramValues[paramName] = {
          value: param.enum[0].value,
          desValue: param.enum[0].value,
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      } 
      else if(param.p_unit && param.p_unit.length > 0) 
      {
        paramValues[paramName] = {
          value:param.p_value ?? '',
          desValue:param.p_value ?? '',
          unit: param.p_unit[0],
          show: param.p_show ?? false,
          engName: param.p_engName,
          unitField: param.p_unitField ?? null,
        };
      } 
      else
      {
        paramValues[paramName] = {
          value:param.p_value ?? '',
          desValue:param.p_value ?? '',
          show: param.p_show ?? false,
          engName: param.p_engName,
        };
      }
    });
    return paramValues;
  };

  // 生成连接线的默认组分摩尔分率
  const generateLinkDefaultMaterials = (globalData: any) => {
    const materials = {};
    if (globalData && globalData.materials) {
      for (let i = 0; i < globalData.materials.length; i++) {
        const name = globalData.materials[i].formula;
        materials[name] = {
          molar_frac: materialsValueMap[name] ?? "",
          desValue: materialsValueMap[name] ?? "",
          cas: globalData.materials[i].cas_code,
          name: globalData.materials[i].formula,
          chineseName: globalData.materials[i].name,
        };
      }
    }
    return materials;
  };

  // 确保所有图元都有 ParamValues
  const ensureAllParamValues = (diagrams: any,globalData: any) => 
  {
    if (!diagrams) return;
    const model = diagrams.model;
    const nodeDataArray = model.nodeDataArray;
    const linkDataArray = model.linkDataArray;

    // 处理节点
    for (const node of nodeDataArray) {
      if (node.isGroup) continue; // 跳过分组节点
      if (node.ParamValues === undefined && (node.elementName || node.nodeName)) 
      {
        const defaultValues = generateNodeDefaultParamValues(node, diagrams);
        model.setDataProperty(node, 'ParamValues', defaultValues);
      }
    }

    // 处理连接线
    for (const link of linkDataArray) 
    {
      if (link.linkName || link.text) {
        // 处理ParamValues
        if (link.ParamValues === undefined || (typeof link.ParamValues === 'object' && Object.keys(link.ParamValues).length === 0)) {
          const defaultValues = generateLinkDefaultParamValues(link);
          model.setDataProperty(link, 'ParamValues', defaultValues);
        }
        // 处理materials
        if (link.materials === undefined || (typeof link.materials === 'object' && Object.keys(link.materials).length === 0)) {
          const defaultMaterials = generateLinkDefaultMaterials(globalData);
          model.setDataProperty(link, 'materials', defaultMaterials);
        }
      }
    }
  };

  // 保存流程图数据的函数
  const saveDiagram = async (isSetPage = false) => 
  {
    // 下面的 if 被注释掉，原本在只读模式下禁止保存
    // if (readonly) {
    //   console.log('只读模式下无法保存');
    //   return;
    // }

    if (!diagrams)
    {
      return false;
    }
    
    setLoadingVariable(true);

    if (diagramRef.current) 
    {
      diagramRef.current.clearAllLinkHighlights();
    }

    // 先确保所有图元都有默认参数值
    ensureAllParamValues(diagrams,globalData);

    let token = userInfo.access_token;
    let flowId = state.curFlow["id"];
    let projectId = state.curFlow["project_id"];

    await updateFlowthum_Pic({project_id:projectId,id:flowId},false);
    return saveFlow(projectId,flowId,JSON.parse(diagrams.model.toJson()),token).then(async (res) => 
    {
      if(res.status===200)
      {
        messageApi.open
        ({
            type: "success",
            content:"保存成功",
        });
        setLoadingVariable(false);

        if(isSetPage)
        {
          if (projectId && flowId && globalData) 
          {
            // 跳转到新的参数查看页面路由（自定义路径，建议和现有格式统一）
            onActionDone?.();
            navigate(`/project/${projectId}/flow/${flowId}/params`,{state:{globalData}});
          }
        }

        return true;
      }
      else
      {
        messageApi.open
        ({
            type: "error",
            content:`保存失败：${res.status}`,
        });
        setLoadingVariable(false);
        return false;
      }
    });
  };

  const copyDiagram =() =>
  {
    if(queryAllProjectStatu===1)
    {
      queryAllProject();
    }
    else if(queryAllProjectStatu===2)
    {
      messageApi.open
      ({
          type: "error",
          content:"正在查询，请稍等",
      });
    }
    else if(queryAllProjectStatu===3)
    { 
      if(allProjectData)
      {
        setSelectCopyFlowUrl("");
        setModalVisible(true);
      }
    }
  };

  const selectCopyFlow = (value,option) => 
  {
    if(option.flow_data_url)
    {
      setSelectCopyFlowUrl(option.flow_data_url);
    }
    else
    {
      messageApi.open
      ({
          type: "error",
          content:`流程：${option.title} 暂无流程图`,
      });
    }
  };

  const queryAllProject =async() =>
  {
    let token = userInfo.access_token;
    setQueryAllProjectStatu(2);
    projectsAll({owner_id: 1},token).then(async(res) => 
    {
      if(res.status===200)
      {
        let newProjectData = res.data.data;
        console.log("allProjectData:",newProjectData);
        setAllProjectData(newProjectData);
        setQueryAllProjectStatu(3);
        setModalVisible(true)
      }
      else
      {
        setQueryAllProjectStatu(1);
        messageApi.open
        ({
            type: "error",
            content:"查询失败，请点击按钮重新查询",
        });
      }
    });
  };

  const confirmCopyDiagram =async() =>
  {
    if(selectCopyFlowUrl!=="")
    {
      let response = await fetch(selectCopyFlowUrl);
      let jsonData = await response.json();
      setDataSource(null);
      setTimeout(() => 
      {
        setDataSource({data:jsonData,cover:''});
      }, 100);
      setModalVisible(false);
    }
    else
    {
      messageApi.open
      ({
          type: "error",
          content:"请选择要粘贴的流程",
      });
    }
  };

  const importDiagram =() =>
  {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.json'; // 只允许选择JSON文件
    // 监听文件选择事件
    fileInput.onchange = (e) => 
    {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;
      // 验证文件类型
      if (file.type !== 'application/json' && !file.name.endsWith('.json')) {
        alert('请选择有效的JSON文件');
        return;
      }
      // 读取文件内容
      const reader = new FileReader();
      reader.onload = (event) => 
      {
        // 解析JSON内容
        const importJson = JSON.parse(event.target?.result as string);
        // 更新流程图数据源

        setDataSource(null);
        setTimeout(() => 
        {
          setDataSource({ data: importJson, cover: '' });
        }, 100);

        // setDataSource({ data: importJson, cover: '' });
      };
      // 以文本方式读取文件
      reader.readAsText(file);
    };
    // 触发文件选择对话框
    fileInput.click();
    // 清理临时创建的DOM元素
    setTimeout(() => {
      fileInput.remove();
    }, 100);
  };

  const exportDiagram =() =>
  {
    let flowName = state.curFlow["name"];

    let jsonData_json = JSON.parse(diagrams.model.toJson());
    // jsonData_json["modelData"] = {"position": "0 0"};
    let jsonData = JSON.stringify(jsonData_json);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = flowName; // 下载的文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const deleteDiagram =() =>
  {
    if(!readonly)
    {
      setDataSource({data:emptyJosn,cover:''});
    }
    else
    {
      setReadonly(false);
    }
  };

  const lastDiagram =() =>
  {
    if (diagrams && diagrams.undoManager) 
    {
      diagrams.undoManager.undo();
    }
  };

  const nextDiagram =() =>
  {
    if (diagrams && diagrams.undoManager) 
    {
      diagrams.undoManager.redo();
    }
  };

  const groupDiagram =() =>
  {
    if (diagrams && diagrams.commandHandler) 
    {
      diagrams.commandHandler.groupSelection();
    }
  };

  const ungroupDiagram =() =>
  {
    if (diagrams && diagrams.commandHandler) 
    {
      diagrams.commandHandler.ungroupSelection();
    }
  };

  const fullScreen =() =>
  {
    if (!document.fullscreenElement) 
    {
      document.documentElement.requestFullscreen();
      setFullScreenViable(true);
    } 
    else 
    {
      document.exitFullscreen();
      setFullScreenViable(false);
    }
  };

  const adaptDiagram = () =>
  {
    if (diagrams && diagrams.zoomToFit) 
    {
      diagrams.zoomToFit();
    }
  };

  const handleData = async () => 
  {
    const jsonData = JSON.parse(diagrams.model.toJson());
    setCurrentJsonDataForTask(jsonData);
    setTaskModalVisible(true);
  };

  const onTaskSuccess = async() => 
  {
    const saveSuccess = await saveDiagram();
    if (saveSuccess) 
    {
      const flowId = state.curFlow["id"];
      navigate(`/project/${state.curFlow.project_id}/flow/${flowId}/task`);
    }
  };

  // const handleData = async() =>
  // {
  //   //提交前先进行保存
  //   let saveDiagramRes = await saveDiagram();
  //   if(saveDiagramRes)
  //   {
  //     let jsonData = JSON.parse(diagrams.model.toJson());
  //     let flowId = state.curFlow["id"];
  //     let flowName = state.curFlow["name"];
  //     let flowDes = state.curFlow["description"]?state.curFlow["description"]:"";
  //     let globlePhysicalMethod = state.globle_physical_method;

  //     let elements = [];
  //     // let selectedBlocks = [];
  //     let streams = [];
  //     let inputStreamsMap = {};
  //     let outputStreamsMap = {};
  //     let groupsMap = {};

  //     let input = 
  //     {
  //       flow_id:flowId,
  //       name:flowName,
  //       description:flowDes,
  //       cal: "True",
  //       mix_input:
  //       {
  //         selected_blocks:[],
  //         global_physical_method:globlePhysicalMethod,
  //         elements:[],
  //         streams:[],
  //       }
  //     };

  //     //处理group数据
  //     let groupDatas = jsonData.nodeDataArray.filter(item=>item.isGroup);
  //     for(let i=0;i<groupDatas.length;i++)
  //     {
  //       let groupKey = groupDatas[i].key;
  //       let groupName = groupDatas[i].keywords;
  //       groupsMap[groupKey] = groupName;
  //     }

  //     //处理streams数据
  //     for(let i=0;i<jsonData.linkDataArray.length;i++)
  //     {
  //       let linkData = jsonData.linkDataArray[i];
  //       if((linkData.linkName)&&(linkData.linkName!==""))
  //       {
  //         let streamsNmae = linkData.linkName;
  //         let streamsSection = "";
  //         let streamsType = "";
  //         let streamsFrom = linkData.from;
  //         let streamsTo = linkData.to;
  //         let streamsFromPort = linkData.fromPort;
  //         let streamsToPort = linkData.toPort;

  //         let streamsParams = {};
  //         if(linkData.ParamValues)
  //         {
  //           for (let key in linkData.ParamValues) 
  //           {
  //             //修改字段名
  //             let field = key;
  //             if(linkData.ParamValues[key].engName&&linkData.ParamValues[key].engName!=="")
  //             {
  //               field = linkData.ParamValues[key].engName;
  //             }
  //             else
  //             {
  //               if(fieldMap2[key]!=undefined)
  //               {
  //                 field = fieldMap2[key];
  //               }
  //             }

  //             //特殊处理
  //             if(field==="type")
  //             {
  //               streamsType = linkData.ParamValues[key].value;
  //               continue;
  //             }

  //             if(linkData.ParamValues[key].unit)
  //             {
  //               let value = linkData.ParamValues[key].value;
  //               if(value!=="")
  //               {
  //                 value = Number(value);
  //                 if(Number.isNaN(value))
  //                 {
  //                   value = null;
  //                 }
  //               }
  //               else
  //               {
  //                 value = null;
  //               }
                  
  //               streamsParams[field] = value;

  //               if(linkData.ParamValues[key].unitField!==undefined)
  //               {
  //                 if(linkData.ParamValues[key].unitField!==null)
  //                 { 
  //                   if(linkData.ParamValues[key].unitField==="")
  //                   {
  //                     streamsParams[`${field}_unit`] = linkData.ParamValues[key].unit;
  //                   }
  //                   else
  //                   {
  //                     streamsParams[linkData.ParamValues[key].unitField] = linkData.ParamValues[key].unit;
  //                   }
  //                 }
  //               }
  //             }
  //             else
  //             {
  //               streamsParams[field] = linkData.ParamValues[key].value;
  //             }
  //           }
  //         }

  //         let materials = [];
  //         if(linkData.materials)
  //         {
  //           for (let key in linkData.materials) 
  //           {
  //             let molarFrac = linkData.materials[key].molar_frac;
  //             if(molarFrac!=="")
  //             {
  //               molarFrac = Number(molarFrac);
  //               if(Number.isNaN(molarFrac))
  //               {
  //                 molarFrac = null;
  //               }
  //             }
  //             else
  //             {
  //               molarFrac = null;
  //             }

  //             let material = 
  //             {
  //               "cas":linkData.materials[key].cas,
  //               "molar_frac":molarFrac,
  //               "name":linkData.materials[key].name
  //             }
  //             materials.push(material);
  //           }
  //         }

  //         let inputStreamMap = 
  //         {
  //           name:streamsNmae,
  //           rule:streamsToPort
  //         };
  //         if(!inputStreamsMap[streamsTo])
  //         {
  //           inputStreamsMap[streamsTo] = [];
  //         }
  //         inputStreamsMap[streamsTo].push(inputStreamMap);

  //         let outputStreamMap = 
  //         {
  //           name:streamsNmae,
  //           rule:streamsFromPort
  //         };
  //         if(!outputStreamsMap[streamsFrom])
  //         {
  //           outputStreamsMap[streamsFrom] = [];
  //         }
  //         outputStreamsMap[streamsFrom].push(outputStreamMap);

  //         if(jsonData.nodeDataArray.filter(item=>(!item.isGroup)&&(item.key===streamsFrom)).length>0)
  //         {
  //           let streamsFromElement = jsonData.nodeDataArray.filter(item=>(!item.isGroup)&&(item.key===streamsFrom))[0];
  //           if(streamsFromElement&&streamsFromElement.group)
  //           {
  //             streamsSection = groupsMap[streamsFromElement.group];
  //           }
  //         }
  //         if(streamsSection==="")
  //         {
  //           if(jsonData.nodeDataArray.filter(item=>(!item.isGroup)&&(item.key===streamsTo)).length>0)
  //           {
  //             let streamsToElement = jsonData.nodeDataArray.filter(item=>(!item.isGroup)&&(item.key===streamsTo))[0];
  //             if(streamsToElement&&streamsToElement.group)
  //             {
  //               streamsSection = groupsMap[streamsToElement.group];
  //             }
  //           }
  //         }

  //         let stream = 
  //         {
  //           name:streamsNmae,
  //           section:streamsSection,
  //           type:streamsType,
  //           params:streamsParams,
  //           materials:materials,
  //         };
  //         streams.push(stream);

  //       }
  //     }

  //     //处理elements数据
  //     for(let i=0;i<jsonData.nodeDataArray.length;i++)
  //     {
  //       let nodeData = jsonData.nodeDataArray[i];
  //       if((nodeData.elementName)&&(nodeData.elementName!==""))
  //       {
  //         let elementNmae = nodeData.nodeName;
  //         let elementPhysicalMethod = nodeData.physical_method;
  //         let elementPhase = nodeData.phase;
  //         let elementMode = nodeData.mode;
  //         let elementKey = nodeData.key;
  //         let elementSection = nodeData.group?nodeData.group:"";
  //         let elemnetInputStreams = [];
  //         let elemnetOutputStreams = [];

  //         //判断元件是否所选
  //         if(!selectedElements.includes(elementNmae))
  //         {
  //           continue;
  //         }

  //         if(elementSection!=="")
  //         {
  //           if(groupsMap[elementSection])
  //           {
  //             elementSection = groupsMap[elementSection];
  //           }
  //         }

  //         let elementType = nodeData.elementName;
  //         if(typeMap2[elementType])
  //         {
  //           elementType = typeMap2[elementType];
  //         }
  //         // if(elementType==undefined)
  //         // {
  //         //   elementType = elementDesc[nodeData.nodeName];
  //         // }

  //         if(elementType!=undefined)
  //         {
  //           if(inputStreamsMap[elementKey])
  //           {
  //             for(let j=0;j<inputStreamsMap[elementKey].length;j++)
  //             {
  //               let streamsName = inputStreamsMap[elementKey][j].name;
  //               let streamsRule= inputStreamsMap[elementKey][j].rule;

  //               if(nodeData.type==="DistilStrict")
  //               {
  //                 if(streamsRule.length>0)
  //                 {
  //                   if(streamsRule[0]==="T")
  //                   {
  //                     //塔顶
  //                     streamsRule = "D";
  //                   }
  //                   else if(streamsRule[0]==="B")
  //                   {
  //                     //塔底
  //                     streamsRule = "B";
  //                   }
  //                   else
  //                   {
  //                     streamsRule = "M";
  //                   }
  //                 }
  //                 else
  //                 {
  //                   streamsRule = "M";
  //                 }
  //               }
  //               else
  //               {
  //                 streamsRule = "M";
  //               }

  //               let elemnetInputStream = 
  //               {
  //                 name:streamsName,
  //                 rule:streamsRule
  //               }
  //               elemnetInputStreams.push(elemnetInputStream);
  //             }
  //           }

  //           if(outputStreamsMap[elementKey])
  //           {
  //             for(let j=0;j<outputStreamsMap[elementKey].length;j++)
  //             {
  //               let streamsName = outputStreamsMap[elementKey][j].name;
  //               let streamsRule= outputStreamsMap[elementKey][j].rule;

  //               if(nodeData.type==="DistilStrict")
  //               {
  //                 if(streamsRule[0]==="T")
  //                 {
  //                   //塔顶
  //                   streamsRule = "D";
  //                 }
  //                 else if(streamsRule[0]==="B")
  //                 {
  //                   //塔底
  //                   streamsRule = "B";
  //                 }
  //                 else
  //                 {
  //                   streamsRule = "M";
  //                 }
  //               }
  //               else
  //               {
  //                 streamsRule = "M";
  //               }

  //               let elemnetOutputStream = 
  //               {
  //                 name:streamsName,
  //                 rule:streamsRule
  //               }
  //               elemnetOutputStreams.push(elemnetOutputStream);
  //             }
  //           }

  //           let elementParams = {};
  //           if(nodeData.ParamValues)
  //           {
  //             for (let key in nodeData.ParamValues) 
  //             {
  //               //修改字段名
  //               let field = key;
  //               if(nodeData.ParamValues[key].engName&&nodeData.ParamValues[key].engName!=="")
  //               {
  //                 field = nodeData.ParamValues[key].engName;
  //               }
  //               else
  //               {
  //                 if(fieldMap2[key]!=undefined)
  //                 {
  //                   field = fieldMap2[key];
  //                 }
  //               }

  //               if(nodeData.ParamValues[key].p_children)
  //               {
  //                 //子数据
  //                 let children = [];
  //                 for(let j=0;j<nodeData.ParamValues[key].p_children.length;j++)
  //                 {
  //                   let childrenData = nodeData.ParamValues[key].p_children[j];
  //                   let childrenParams = {};
  //                   for (let childrenKey in childrenData)
  //                   {
  //                     let childrenfield = childrenKey;
  //                     if(childrenData[childrenKey].engName&&childrenData[childrenKey].engName!=="")
  //                     {
  //                       childrenfield = childrenData[childrenKey].engName;
  //                     }
  //                     else
  //                     {
  //                       if(fieldMap2[childrenKey]!=undefined)
  //                       {
  //                         childrenfield = fieldMap2[childrenKey];
  //                       }
  //                     }

  //                     if(childrenData[childrenKey].unit)
  //                     {
  //                       let childrenValue = childrenData[childrenKey].value;
  //                       if(childrenValue!=="")
  //                       {
  //                         childrenValue = Number(childrenValue);
  //                         if(Number.isNaN(childrenValue))
  //                         {
  //                           childrenValue = null;
  //                         }
  //                       }
  //                       else
  //                       {
  //                         childrenValue = null;
  //                       }
  //                       childrenParams[childrenfield] = childrenValue;
  //                     }
  //                     else
  //                     {
  //                       let childrenValue = childrenData[childrenKey].value;
  //                       if(childrenValue==="")
  //                       {
  //                         childrenValue = null;
  //                       }
  //                       childrenParams[childrenfield] = childrenValue;
  //                     }
  //                   }
  //                   children.push(childrenParams);
  //                 }

  //                 //特殊处理
  //                 if((nodeData.type==="DistilStrict")&&((field==="Ns")||(field==="No")))
  //                 {
  //                   children = [];
  //                   if(field==="Ns")
  //                   {
  //                     //进料
  //                     for(let j=0;j<elemnetInputStreams.length;j++)
  //                     {
  //                       let childrenValue = null;
  //                       let childrenDatas = nodeData.ParamValues[key].p_children.filter(item=>item["流股"].value===elemnetInputStreams[j].name);
  //                       if(childrenDatas.length>0)
  //                       {
  //                         childrenValue = childrenDatas[0]["进料位置"].value;
  //                         childrenValue = Number(childrenValue);
  //                         if(Number.isNaN(childrenValue))
  //                         {
  //                           childrenValue = null;
  //                         }
  //                       }
  //                       children.push(childrenValue);
  //                     }
  //                   }
  //                   else if(field==="No")
  //                   {
  //                     //出料
  //                     for(let j=0;j<elemnetOutputStreams.length;j++)
  //                     {
  //                       let childrenValue = null;
  //                       let childrenDatas = nodeData.ParamValues[key].p_children.filter(item=>item["流股"].value===elemnetOutputStreams[j].name);
  //                       if(childrenDatas.length>0)
  //                       {
  //                         childrenValue = childrenDatas[0]["出料位置"].value;
  //                         childrenValue = Number(childrenValue);
  //                         if(Number.isNaN(childrenValue))
  //                         {
  //                           childrenValue = null;
  //                         }
  //                       }
  //                       children.push(childrenValue);
  //                     }
  //                   }
  //                 }
  //                 if((nodeData.type==="Splitter")&&(field==="output_f"))
  //                 {
  //                   children = [];
  //                   //出料
  //                   for(let j=0;j<elemnetOutputStreams.length;j++)
  //                   {
  //                     let childrenValue = null;
  //                     let childrenDatas = nodeData.ParamValues[key].p_children.filter(item=>item["流股"].value===elemnetOutputStreams[j].name);
  //                     if(childrenDatas.length>0)
  //                     {
  //                       childrenValue = childrenDatas[0]["输出流量"].value;
  //                       childrenValue = Number(childrenValue);
  //                       if(Number.isNaN(childrenValue))
  //                       {
  //                         childrenValue = null;
  //                       }
  //                     }
  //                     children.push(childrenValue);
  //                   }
  //                 }

  //                 elementParams[field] = children;
  //               }
  //               else
  //               {
  //                 //常规数据
  //                 if(nodeData.ParamValues[key].unit)
  //                 {
  //                   let value = nodeData.ParamValues[key].value;
  //                   if(value!=="")
  //                   {
  //                     value = Number(value);
  //                     if(Number.isNaN(value))
  //                     {
  //                       value = null;
  //                     }
  //                   }
  //                   else
  //                   {
  //                     value = null;
  //                   }

  //                   elementParams[field] = value;

  //                   if(nodeData.ParamValues[key].unitField!==undefined)
  //                   {
  //                     if(nodeData.ParamValues[key].unitField!==null)
  //                     { 
  //                       if(nodeData.ParamValues[key].unitField==="")
  //                       {
  //                         elementParams[`${field}_unit`] = nodeData.ParamValues[key].unit;
  //                       }
  //                       else
  //                       {
  //                         elementParams[nodeData.ParamValues[key].unitField] = nodeData.ParamValues[key].unit;
  //                       }
  //                     }
  //                   }
  //                 }
  //                 else
  //                 {
  //                   let value = nodeData.ParamValues[key].value;
  //                   if(value==="")
  //                   {
  //                     value = null;
  //                   }

  //                   //特殊处理
  //                   if((nodeData.type==="DistilStrict")&&(field==="type"))
  //                   {
  //                     let elementName = nodeData.elementName;
  //                     value = towerJson.filter(item=>item.nodeName===elementName)?.[0]?.type;
  //                   }

  //                   elementParams[field] = value;
  //                 }
  //               }
  //             }
  //           }

  //           let element = 
  //           {
  //             mode:elementMode,
  //             name:elementNmae,
  //             phase:elementPhase,
  //             physical_method:elementPhysicalMethod,
  //             section:elementSection,
  //             type:elementType,
  //             params:elementParams,
  //             inputStreams:elemnetInputStreams,
  //             outputStreams:elemnetOutputStreams,
  //           };
  //           elements.push(element);
  //           // selectedBlocks.push(elementNmae);
  //         }
  //       }
  //     }

  //     input.mix_input.elements = elements;
  //     input.mix_input.streams = streams;
  //     input.mix_input.selected_blocks = selectedElements;

  //     console.log("state:",state);
  //     console.log("jsonData:",jsonData);
  //     console.log("selectedElements:",selectedElements)
  //     console.log("input:",input);

  //     let token = userInfo.access_token;
  //     const tempupdate ={
  //       name:input.name,
  //       mix_input:input69.inputs,
  //       flow_id:params.f,
  //       cal:"True",
  //       description:"",
  //     };
  //     //暂时先提交测试数据
  //     simulation(tempupdate,token).then(async (res) => 
  //     // simulation(input,token).then(async (res) => 
  //     {
  //       if(res.status===200)
  //       {
  //         messageApi.open
  //         ({
  //             type: "success",
  //             content:"提交成功",
  //         });
  //         //提交成功后后续逻辑

  //         navigate(`/project/${state.curFlow.project_id}/flow/${flowId}/task`);
  //       }
  //       else
  //       {
  //         messageApi.open
  //         ({
  //             type: "error",
  //             content:`提交失败：${res.status}`,
  //         });
  //       }
  //     });
  //   }
  // };

  useEffect(() => 
  {
    saveDiagramRef.current = saveDiagram;
  }, [saveDiagram]);

  useEffect(() => 
  {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        if (saveDiagramRef.current) {
          saveDiagramRef.current();
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => 
  {
    if(action === "deleteDiagram") 
    {
      deleteDiagram();
      onActionDone?.();
    } 
    else if(action === "handleData") 
    {
      handleData();
      setTaskModalVisible(true);
      onActionDone?.();
    }
    else if(action === "saveDiagram") 
    {
      saveDiagram(true);
      // onActionDone?.();

      // // 校验参数，避免跳转失败
      // let flowId = state.curFlow["id"];
      // let projectId = state.curFlow["project_id"];
      // if (projectId && flowId && globalData) 
      // {
      //   // 跳转到新的参数查看页面路由（自定义路径，建议和现有格式统一）
      //   navigate(`/project/${projectId}/flow/${flowId}/params`,{state:{globalData}});
      // }
    } 
  }, [action,onActionDone]);

  // 返回组件的 JSX 结构
  return (
    <>
      {contextHolder}

      {loadingVariable?(
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"rgba(150,170,200,0.3)",zIndex:1000,fontSize:44,fontWeight:"bold",color:"#1b6ae7"}}>
          <LoadingOutlined style={{ fontSize:48, marginRight:30}} />
          <span>保存中</span>
        </div>
      ):null}

      <div className="diagram_component" style={{padding:0,margin:0}}>
        <div style={{display:"flex",flexDirection:"row",height:25,background:"#EEE",paddingLeft:15,border:"solid #BBB",borderWidth:"1px 0 1px 0"}}>
          <button
            onClick={()=>{setReadonly(true);}}
            style={{width:90,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 1px",background:readonly?"#BBB":"#EEE",color:readonly?"#000":"#5F5F5F",fontSize:12}}
          >
            <EyeOutlined style={{marginRight:10}}/>
            只读模式</button>
          {allowUpDiagrams&&(
            <button
              onClick={()=>{setReadonly(false);}}
              disabled={!allowUpDiagrams}
              style={{width:90,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:!readonly?"#BBB":"#EEE",color:!readonly?"#000":"#5F5F5F",fontSize:12}}
            >
              <EditOutlined style={{marginRight:10}}/>
              编辑模式</button>
          )}  
          <button
            onClick={()=>{saveDiagram();}}
            style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >
            <SaveOutlined style={{marginRight:10}}/>
            保存</button>
          <button
            onClick={()=>{setOverviewVisible(!overviewVisible)}}
            style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:overviewVisible?"#BBB":"#EEE",color:overviewVisible?"#000":"#5F5F5F",fontSize:12}}
          >
            <SwapOutlined style={{marginRight:10}}/>
            缩略图</button>
          {!readonly&&(
              <button
              onClick={deleteDiagram}
              style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
            >
              <FileOutlined style={{marginRight:10}}/>
              清空</button>
          )}
          {!readonly&&(
            <button
              onClick={lastDiagram}
              style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
            >
              <UndoOutlined style={{marginRight:10}}/>
              撤销</button>
          )}
          {!readonly&&(
          <button
            onClick={nextDiagram}
            style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >
            <RedoOutlined style={{marginRight:10}}/>
            重做</button>
          )}
          {!readonly&&(
            <button
              onClick={groupDiagram}
              style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
            >
              <GroupOutlined style={{marginRight:10}}/>
              分组</button>
          )}
          {!readonly&&(
            <button
              onClick={ungroupDiagram}
              style={{width:80,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
            >
              <UngroupOutlined style={{marginRight:10}}/>
              取消分组</button>
          )}
          {!readonly&&(
            <button
              onClick={copyDiagram}
              style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:queryAllProjectStatu!==2?"#EEE":"#BBB",color:"#5F5F5F",fontSize:12}}            
            >
              {queryAllProjectStatu === 2 ? <LoadingOutlined style={{marginRight:10}}/>:<CopyOutlined style={{marginRight:10}}/>}
              粘贴</button>
          )}
          <div
            style={{display:"flex",flexDirection:"row",alignItems: "center",width:140,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >
            <ExpandAltOutlined style={{marginLeft:10,marginRight:10}}/>
            缩放
            <Input
              value={screenSize}
              suffix="%"
              onChange={(e) => 
              {
                const newValueStr = e.target.value;
                if (newValueStr === "") 
                {
                  messageApi.open
                  ({
                      type: "error",
                      content:"请输入数字",
                  });
                } 
                else 
                {
                  const newValue = Number(newValueStr);
                  if (!isNaN(newValue)) 
                  {
                    setScreenSize(newValue);
                  }
                  else
                  {
                    messageApi.open
                    ({
                        type: "error",
                        content:"请输入数字",
                    });
                  }
                }
              }}
              onPressEnter={(e) => 
              {
                const newValueStr = e.target["value"];
                let newValue = null;
                if(newValueStr!=="")
                {
                  newValue = Number(newValueStr);
                  if(Number.isNaN(newValue))
                  {
                    newValue = null;
                  }
                }
                if(newValue)
                {
                  setScreenSize(newValue);
                  //此处更改画面缩放尺寸
                  if (diagrams) 
                  {
                    diagrams.scale = newValue / 100;
                  }
                }
                else
                {
                  messageApi.open
                  ({
                      type: "error",
                      content:"请输入数字",
                  });
                }
              }}
              style={{marginLeft:10,width:65,height:"80%",borderRadius:0,fontSize:12,paddingBottom:0,paddingTop:0,color:"#5F5F5F"}}
            />
          </div>
          <button
            onClick={fullScreen}
            style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >
            {fullScreenViable?(<FullscreenOutlined style={{marginRight:10}}/>):(<FullscreenExitOutlined style={{marginRight:10}}/>)}
            {fullScreenViable?"窗口":"全屏"}</button>
          <button
            onClick={adaptDiagram}
            style={{width:90,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >
            <ExpandOutlined style={{marginRight:10}}/>
            适应屏幕</button>
          <button
            onClick={importDiagram}
            style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >
            <VerticalAlignBottomOutlined style={{marginRight:10}}/>
            导入</button>
          <button
            onClick={exportDiagram}
            style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >
            <VerticalAlignTopOutlined style={{marginRight:10}}/>
            导出</button>
          
          {diagrams ?(
            <div
              style={{display:"flex",flexDirection:"row",alignItems: "center",width:225,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
            >
              <SearchOutlined style={{marginLeft:10,marginRight:10}}/>
              查找
              <SearchElement
                style={{marginLeft:10,width:150,height:18.39,borderRadius:0,fontSize:12,paddingBottom:0,paddingTop:0,color:"#5F5F5F"}}
                diagrams={diagrams}
                searchElementChange={(newSearchElement,newSelectType) => {setSearchElementName({name:newSearchElement,type:newSelectType});}}
              />
            </div>
          ):null}

          {/* <button
            onClick={handleData}
            style={{width:70,height:"100%",border:"solid #BBB",borderWidth:"0 1px 0 0",background:"#EEE",color:"#5F5F5F",fontSize:12}}
          >测试</button> */}
          {/* <button
            onClick={toggleReadOnlyMode}
            style={{width:60,height:"100%",border:"1px solid #BBB",background:"#EEE",color:"#5F5F5F",fontSize:12}}
            // style={{ marginLeft: '15px', backgroundColor: readonly ? '#4CAF50' : '#FF9800' }}
          >
            {readonly ? '切换到编辑模式' : '切换到只读模式'}
          </button> */}
        </div>
        {/* 只有当 dataSource 有值时（即数据已加载），才渲染流程图相关组件 */}
        {dataSource ? <>
          {/* 流程图主组件，接收以下 props：
              diagrams: 当前 mxGraph 实例
              settings: 包含 readonly 设置
              setDiagrams: 更新 diagrams 状态的函数（可能用于接收实例引用）
              dataSource: 初始流程图数据（图形结构）
          */}
          <div onContextMenu={(e) => e.preventDefault()}>
            <Diagram
              diagrams={diagrams}
              settings={{
                readonly: readonly,
              }}
              setDiagrams={setDiagrams}
              dataSource={dataSource.data}
              overview={overviewVisible}
              globalData={globalData}
              onScaleChange={(scalePercent) => setScreenSize(scalePercent)}
              diagramsRef={diagramRef}
            />
          </div>
          {/* 如果 diagrams 实例已存在，则渲染 Palette 和 Overview 组件 */}
          {diagrams && (
            <>
              {/* Palette 组件提供拖拽图形库，仅当非只读模式时才显示（!readonly） */}
              {!readonly && diagrams && (
                  <div style={{height:180,width:"100%",position: 'absolute', bottom: '0px',zIndex: 100}}>
                    <Palette diagrams={diagrams} />
                  </div>
                )}
              {/* Overview 缩略图组件，始终显示（但受 show 属性控制），show 为 overview 状态 */}
              <Overview diagrams={diagrams} show={overview} />
            </>
          )}
        </> : ''} {/* 如果 dataSource 为空，则不渲染任何内容 */}
      </div>

      <Modal
        closable={false}
        centered={true}
        footer={null}
        width={500}
        className={"modal"}
        open={modalVisible}
        onCancel={()=>{setModalVisible(false);}}
      >
        <div style={{marginBottom:20,fontSize:20,fontWeight:"bold",color:"#1b6ae7"}}>粘贴流程图</div>
        <div>
          <TreeSelect
            showSearch
            allowClear={false}
            defaultOpen={false}
            multiple={false}
            treeDefaultExpandAll={true}
            virtual={false}
            style={{ width: '100%' }}
            styles={{
              popup: {
                root: { maxHeight: 400, overflow: 'auto' },
              },
            }}
            placeholder="请选择流程"
            onSelect={selectCopyFlow}
            treeData={(allProjectData || []).map(({ id,name,flows, ...rest }) => ({ ...rest, title: name, value: id,disabled:flows,children: (flows || []).map(({ name: flowName,id, ...flowRest }) => ({ ...flowRest, title: flowName,value:id })) }))}
          />
        </div>
        <div style={{height:32}}>
          <button
            onClick={()=>{{setModalVisible(false);}}}
            style={{position:"absolute",right:25,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#FF4D4F",color:"#FFF",fontSize:14}}
          >取消</button>
          <button
            onClick={()=>{confirmCopyDiagram();}}
            style={{position:"absolute",right:138,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#1b6ae7",color:"#FFF",fontSize:14}}
          >确认</button>
        </div>
      </Modal>
      
      <SelectElementsModal
        // notificationApi={notificationApi}
        // notificationKey={notificationKey}
        visible={taskModalVisible}
        jsonData={currentJsonDataForTask}
        onClose={() => setTaskModalVisible(false)}
        onSuccess={onTaskSuccess}
        state={state}
      />

    </>
  );
};

export default Component; // 导出组件，供其他模块使用